<template>
  <div class="btn" @click="handleClick">
    <slot/>
  </div>
</template>

<script>
    export default {
        name: "ZButton",
        methods: {
            handleClick() {
                this.$emit("click")
            }
        }
    }
</script>

<style lang="scss" scoped>
  .btn {
    @include button-theme;
    
    user-select: none;
    width: 80%;
    margin: 0 auto 20px;
    height: 40px;
    line-height: 40px;
    opacity: 1;
    border-radius: 26px;
    font-size: 16px;
    text-align: center;
    cursor: pointer;
  }

  .btn:hover {
    @include button-theme-hover;
  }

  .btn[type="warning"] {
    background: rgba(255, 0, 0, 0.1);
    border: 1px solid rgba(255, 0, 0, 1);
    color: rgba(255, 0, 0, 1);
  }

  .btn[type="warning"]:hover {
    background: rgba(255, 0, 0, 1);
    color: rgba(255, 255, 255, 1);
  }
</style>



// WEBPACK FOOTER //
// src/components/TableToolBar/TButton.vue